import executeAction from './utils/executeAction';
import parseLegacyMessageCardAction from './utils/parseLegacyMessageCardAction';
import processAutoInvokeAction from './utils/processAutoInvokeAction';
import registerActions from './utils/registerActions';
import registerHostCapabilities from './utils/registerHostCapabilities';
import { ActionProvider } from 'owa-actionable-message-v2';

const actionProvider: ActionProvider = {
    registerActions: registerActions,
    executeAction: executeAction,
    parseLegacyMessageCardAction: parseLegacyMessageCardAction,
    processAutoInvokeAction: processAutoInvokeAction,
    registerHostCapabilities: registerHostCapabilities,
};

export { actionProvider };
export { default as makeDownloadThemeRequest } from './service/makeDownloadThemeRequest';
export { default as doesActionableMessageEnabledByTenant } from './utils/doesActionableMessageEnabledByTenant';
export { default as isOriginatorBlocked } from './utils/isOriginatorBlocked';
export { default as fixExternalInlineImages } from './utils/fixExternalInlineImages';
export { default as isTrustedDomain } from './utils/isTrustedDomain';
export { default as getActionableMessageHttpChannelUrl } from './utils/getActionableMessageHttpChannelUrl';
export { default as getSnackBarTimeout } from './selectors/getSnackBarTimeout';
